import { useEffect } from 'react'
import { Platform, Pressable, View } from 'react-native'
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withSpring,
} from 'react-native-reanimated'
import { useStagesStore } from 'hooks/useStagesStore'
import { listPresets, Preset } from '@shell/Topbar/types'
import { topbar } from '@ui/theme/values'
import { useStages } from 'hooks/useStagesStore'
import cn from '@ui/utils/cn'

import Labels from './Labels'
import { useAnimatedOpacity } from '@ui/animated/useAnimatedOpacity'

function Stage({ preset }: { preset: Preset }) {
  const presetActive = useStagesStore((state) => state.preset)
  const { getStageIndex, getLables } = useStages()
  const isActive = preset === presetActive

  const index = getStageIndex()
  const labels = getLables(preset)

  const animatedActive = useSharedValue(isActive ? 1 : 0)
  const styleStage = useAnimatedStyle(() => ({
    opacity: interpolate(animatedActive.value, [0, 1], [0, 1]),
  }))

  useEffect(() => {
    animatedActive.set(withSpring(isActive ? 1 : 0))
  }, [isActive])

  return (
    <Animated.View
      className={cn(
        'absolute inset-0 items-center justify-center',
        Platform.OS !== 'web' && 'w-full'
      )}
      style={[styleStage]}
    >
      <Labels key={preset} active={index} labels={labels} isActive={isActive} />
    </Animated.View>
  )
}

export default function Stages() {
  const isLogo = useStagesStore((state) => state.isLogo)

  const styleOpacity = useAnimatedOpacity(!isLogo)

  return (
    <>
      <Animated.View
        className="absolute w-full items-center justify-center"
        style={[styleOpacity, { height: topbar.height }]}
      >
        {listPresets.map((preset: Preset) => (
          <Stage key={preset} preset={preset} />
        ))}
      </Animated.View>
    </>
  )
}
